import { renderSettingsResourceLabel } from "../../../../../../../utils/helpers/settings";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";

const renderItem = (value, label, t) => {
    const newValue = value?.new;
    const oldValue = value?.old;

    let content;

    if (typeof newValue === "boolean") {
        content = (
            <>
                {typeof oldValue === "boolean" && <OldValue value={oldValue ? t("active") : t("not-active")} />}

                <NewValue value={newValue ? t("active") : t("not-active")} />
            </>
        );
    } else if (typeof newValue === "number") {
        content = (
            <>
                {oldValue && <OldValue value={oldValue} />}

                <NewValue value={newValue} />
            </>
        );
    } else if (typeof newValue === "string") {
        content = (
            <>
                {oldValue && <OldValue value={oldValue} />}

                <NewValue value={newValue} />
            </>
        );
    } else {
        content = (
            <>
                {oldValue && <OldValue value={renderSettingsResourceLabel(oldValue)} />}

                <NewValue value={renderSettingsResourceLabel(newValue)} />
            </>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2 mb-1 w-100">
            <Label value={t(label)} />
            {content}
        </div>
    );
};

export default renderItem;
